module.exports = __webpack_public_path__ + "38743f0f14fc81e1eed9b32858f2e275.pdf";